export const ticketsQueryKeys = {
    all: ['fields'] as const,
    lists: () => [...ticketsQueryKeys.all, 'list'] as const,
    list: (filters: object) => [...ticketsQueryKeys.lists(), filters] as const,
    details: () => [...ticketsQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...ticketsQueryKeys.details(), id] as const,
};
